import { render, staticRenderFns } from "./ClientInvoiceView.vue?vue&type=template&id=6a62161c&"
import script from "./ClientInvoiceView.vue?vue&type=script&lang=js&"
export * from "./ClientInvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports